<template>
  <modal 
    name="add-asset-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'650px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        Please select an asset type
      </div>

      <a href="#"
        @click.prevent="$modal.hide('add-asset-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body">
      <div class="flex flex-wrap -mx-2">
				<div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(0)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Money-Increase-128.png" class="inline w-12" />
            <div class="mt-2">Savings<br/>&nbsp;</div>
          </button>
        </div>

        <div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(1)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Tower-128.png" class="inline w-12" />
            <div class="mt-2">Owner Occupied Property</div>
          </button>
        </div>

        <div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(2)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Apartment-128.png" class="inline w-12" />
            <div class="mt-2">Investment Property</div>
          </button>
        </div>

        <div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(3)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Old-Car-2-128.png" class="inline w-12" />
            <div class="mt-2">Vehicle<br/>&nbsp;</div>
          </button>
        </div>

        <div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(4)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Canoe-128.png" class="inline w-12" />
            <div class="mt-2">Home Contents</div>
          </button>
        </div>

        <div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(5)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Gold-Cart-128.png" class="inline w-12" />
            <div class="mt-2">Superannuation</div>
          </button>
        </div>

        <div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(6)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Money-Graph-128.png" class="inline w-12" />
            <div class="mt-2">Investments</div>
          </button>
        </div>

        <div class="w-1/2 lg:w-1/4 p-2">
          <button class="item-button" v-on:click="addAssetLocal(7)">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Baby-Mobile-128.png" class="inline w-12" />
            <div class="mt-2">Other</div>
          </button>
        </div>
      </div>

      <div class="mt-4 pt-4 border-t flex items-center" v-if="templates != null && templates.length > 0">
        <div class="text-base">
          Add assets via template
        </div>

        <select v-on:change="templateSelectedLocal" class="ml-4 border border-gray-500">
          <option>Select a template</option>
          <template v-for="(template, index) in templates">
            <option :value="template.id">{{ template.name }}</option>
          </template>
        </select>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {

    props : {
      templates : {
        type     : Array,
        required : false
      },

      templateSelected : {
        type     : Function,
        required : false
      }
    },

    data() {
      return {
        addAsset : null
      }
    },

    methods : {
      beforeOpen(event) {
        this.addAsset = event.params.addAsset
      },

      addAssetLocal(type) {
        this.addAsset(type)
        this.$modal.hide('add-asset-modal')
      },

      templateSelectedLocal(e) {
        this.templateSelected(e.target.value)
        this.$modal.hide('add-asset-modal')
      }
    }
  }
</script>